import React from "react";
import { DragDropContext, DragSource, DropTarget } from 'react-dnd';
import { Table } from 'antd';
import HTML5Backend from 'react-dnd-html5-backend';
import update from 'immutability-helper';

// 拖拉方向
function dragDirection(
    dragIndex,
    hoverIndex,
    initialClientOffset,
    clientOffset,
    sourceClientOffset,
) {
    const hoverMiddleY = (initialClientOffset.y - sourceClientOffset.y) / 2;
    const hoverClientY = clientOffset.y - sourceClientOffset.y;
    if (dragIndex < hoverIndex && hoverClientY > hoverMiddleY) {
        return 'downward';
    }
    if (dragIndex > hoverIndex && hoverClientY < hoverMiddleY) {
        return 'upward';
    }
}

// 拖拉内容
class BodyRow extends React.Component {
    render() {
        const {
            isOver,
            connectDragSource,
            connectDropTarget,
            moveRow,
            dragRow,
            clientOffset,
            sourceClientOffset,
            initialClientOffset,
            ...restProps
        } = this.props;
        const style = { ...restProps.style, cursor: 'move' };

        let className = restProps.className;
        if (isOver && initialClientOffset) {
            const direction = dragDirection(
                dragRow.index,
                restProps.index,
                initialClientOffset,
                clientOffset,
                sourceClientOffset
            );
            // 拖拉添加样式
            if (direction === 'downward') {
                className += ' drop-over-downward';
            }
            if (direction === 'upward') {
                className += ' drop-over-upward';
            }
        }

        return connectDragSource(
            connectDropTarget(
                <tr
                    {...restProps}
                    className={className}
                    style={style}
                />
            )
        );
    }
}

const rowSource = {
    beginDrag(props) {
        return {
            index: props.index,
        };
    },
};

const rowTarget = {
    drop(props, monitor) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;
        if (dragIndex === hoverIndex) {
            return;
        }
        props.moveRow(dragIndex, hoverIndex);
        monitor.getItem().index = hoverIndex;
    },
};

const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    sourceClientOffset: monitor.getSourceClientOffset(),
}))(
    DragSource('row', rowSource, (connect, monitor) => ({
        connectDragSource: connect.dragSource(),
        dragRow: monitor.getItem(),
        clientOffset: monitor.getClientOffset(),
        initialClientOffset: monitor.getInitialClientOffset(),
    }))(BodyRow)
);

// 拖拉组件
class DragSortingTable extends React.Component {

    static defaultProps = {
        tableOption: {},
        onChange: Function.prototype,//拖拉行之后的函数，返回新的排列数据
    };

    state = {
        data: [],
    }

    componentDidMount() {
        this.setState({
            data: this.props.tableOption.dataSource,
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.tableOption.dataSource != this.state.data) {
            this.setState({
                data: nextProps.tableOption.dataSource
            })
        }
    }

    components = {
        body: {
            row: DragableBodyRow,
        },
    }

    moveRow = (dragIndex, hoverIndex) => {
        if (this.props.disabled)
            return;
        const { data } = this.state;
        const dragRow = data[dragIndex];
        let newData = update(this.state.data, { $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]] })
        this.setState({
            data: newData
        }, () => {
            this.props.onChange(newData)
        });
    }

    render() {
        const { tableOption } = this.props;
        const { dataSource, components, ...otherTable } = tableOption;
        return (
            <Table
                {...otherTable}
                dataSource={this.state.data}
                components={this.components}
                onRow={(record, index) => {
                    return {
                        index: index,
                        moveRow: this.moveRow,
                    }
                }}
            />
        );
    }
}

const DragTable = DragDropContext(HTML5Backend)(DragSortingTable);

export default DragTable


// WEBPACK FOOTER //
// ./components/custom/DragTable/index.js